import { MAIN_CALCULATOR_ELEMENT_ID } from "./contants";

const getCalculatorNode = () => {
  return document?.getElementById(MAIN_CALCULATOR_ELEMENT_ID);
};

export const scrollToCalculatorNode = () => {
  const calculatorNode = getCalculatorNode();

  if (calculatorNode) {
    calculatorNode.scrollIntoView({ behavior: "smooth" });
  }
};
